import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

class StudentCourseHelper{


    async getAvailableCourses(params = {}) {
        try {
          const response = await ApiHelper.get(API_ENDPOINTS.STUDENTS.COURSES.AVAILABLE_COURSES, params);
          return response;
        } catch (error) {
          throw new Error(`Failed to fetch available courses: ${error.message}`);
        }
    }
    
    async getEnrolledCourses(params = {}) {
        try {
          const response = await ApiHelper.get(API_ENDPOINTS.STUDENTS.COURSES.ENROLLED_COURSES, params);
          return response;
        }
        catch (error) {
          throw new Error(`Failed to fetch enrolled courses: ${error.message}`);
        }
    }
    async enrollInCourse(courseId) {
        try {
          const response = await ApiHelper.post(API_ENDPOINTS.STUDENTS.COURSES.ENROLL,courseId);
          return response;
        } catch (error) {
          throw new Error(`Failed to enroll in course: ${error.message}`);
        }
    }
    async unenrollFromCourse(data) {
        try {
          const response = await ApiHelper.post(API_ENDPOINTS.STUDENTS.COURSES.UNENROLL,data);
          return response;
        } catch (error) {
          throw new Error(`Failed to unenroll from course: ${error.message}`);
        }
    }

    async notifications(courseId) {
        try {
          const response = await ApiHelper.get(API_ENDPOINTS.STUDENTS.COURSES.NOTIFICATIONS(courseId));
          return response;
        } catch (error) {
          throw new Error(`Failed to fetch notifications: ${error.message}`);
        }
    }

      async getCourseContents(courseId, filters = {}) {
        try {
            const queryParams = new URLSearchParams(filters).toString();
            const url = API_ENDPOINTS.STUDENTS.COURSES.CONTENTS(courseId) + (queryParams ? `?${queryParams}` : '');
            console.log("yaha hai url", url);
            const response = await ApiHelper.get(url);
            return response;
        } catch (error) {
            throw new Error(`Failed to fetch course contents: ${error.message}`);
        }
    }

    async getContentStats(courseId) {
        try {
            const response = await ApiHelper.get(API_ENDPOINTS.STUDENTS.COURSES.CONTENT_STATS(courseId));
            return response;
        } catch (error) {
            throw new Error(`Failed to fetch content stats: ${error.message}`);
        }
    }

    async getContentById(contentId) {
        try {
            const response = await ApiHelper.get(API_ENDPOINTS.STUDENTS.CONTENTS.GET_BY_ID(contentId));
            return response;
        } catch (error) {
            throw new Error(`Failed to fetch content: ${error.message}`);
        }
    }

    async updateContentProgress(contentId, progressData) {
        try {
            const response = await ApiHelper.post(
                API_ENDPOINTS.STUDENTS.CONTENTS.UPDATE_PROGRESS(contentId),
                progressData
            );
            return response;
        } catch (error) {
            throw new Error(`Failed to update progress: ${error.message}`);
        }
    }

    async markContentComplete(contentId) {
        try {
            const response = await ApiHelper.post(
                API_ENDPOINTS.STUDENTS.CONTENTS.MARK_COMPLETE(contentId)
            );
            return response;
        } catch (error) {
            throw new Error(`Failed to mark content as complete: ${error.message}`);
        }
    }

    async getNextContent(courseId) {
        try {
            const response = await ApiHelper.get(API_ENDPOINTS.STUDENTS.COURSES.NEXT_CONTENT(courseId));
            return response;
        } catch (error) {
            throw new Error(`Failed to fetch next content: ${error.message}`);
        }
    }


}

export default new StudentCourseHelper();